<template>
    <div id="streaming-container" class="flex-cl-center-start">
        <br>
        <div>
            This page will get an overhaul soon.
        </div>
        <br>
      <div id="button-container">
        <div id="action-buttons">
          <v-btn
              large
              class="ma-2 white--text"
              id="flow-button"
              v-on:click="showFlow()"
          >
            Flow Stream
          </v-btn>
          <v-btn
              large
              class="ma-2 white--text"
              id="darkpool-button"
              v-on:click="showDark()"
          >
            Dark Pool Stream
          </v-btn>
          <v-btn
                  large
                  class="ma-2 white--text"
                  id="sector-button"
                  v-on:click="showSector()"
          >
            Sector Flow
          </v-btn>
          <v-btn
                  large
                  class="ma-2 white--text"
                  id="crypto-button"
                  v-on:click="showCryptoFlow()"
          >
            Crypto Stream
          </v-btn>
          <v-btn
                  large
                  class="ma-2 white--text"
                  id="short-button"
                  v-on:click="showShorts()"
          >
            Short Data
          </v-btn>
          <v-btn
              large
              class="ma-2 white--text"
              id="account-button"
              v-on:click="showAccount()"
          >
            Account / Sign Up
          </v-btn>
        </div>
      </div>
      <br><br>
      <div class="flex-row-center-between">
        <h1>Economic Calendar</h1>
        <div class="tradingview-widget-container">
          <div class="flex-row-center-between" id="chart"></div>
        </div>
      </div>

      <script type="application/javascript" src="https://s3.tradingview.com/external-embedding/embed-widget-events.js" async>
            {
                "colorTheme": "dark",
                "isTransparent": false,
                "width": "80%",
                "height": "80%",
                "locale": "en",
                "importanceFilter": "-1,0,1"
            }
        </script>




        </div>
</template>

<script>
    import {abbreviateNumber} from "@/helpers/formatting";
    import {mapActions} from "vuex";
    //import {checkCookie, COOKIE_USER_AUTH, COOKIE_USER_ID, getCookie} from "../../utils/CookieHelper";
    import {BASE_URL} from "../../utils/constants";
    const ENDPOINT  = "api/v1/users/"
    import apiService from '@/api/daily-data';

    export default {
        name: "Dash",
        props: {
            widgetMode: Boolean
        },
        beforeMount() {
            if (!this.widgetMode) {
                this.tableHeight = `${window.innerHeight - 270}`;
            }
        },
        async mounted() {
            // Send user back if not logged in
            // if (!checkCookie(COOKIE_USER_ID) || !checkCookie(COOKIE_USER_AUTH)) {
            //     await this.$router.push({name: "Login"})
            //  }
            //  this.getProfile(getCookie(COOKIE_USER_ID), getCookie(COOKIE_USER_AUTH));
            this.setLogoAndBottomNavVisibility(false);

            let backlog = await apiService.getFlowData();
            this.printData = await backlog.json();
            this.prints = this.printData;

            this.loading = false;

        },
        beforeDestroy() {
            this.setLogoAndBottomNavVisibility(true);
        },
        data: () => ({
            lightPrintColorMap: {
                "Light_A": "#025c1d",
                "Light_B": "#ab4f2b",
                "Light_I": "#2180CE",
            },
            sectorColorMap: {
                "Basic Materials": "#666e18",
                "Communication Services": "#DE832F",
                "Consumer Cyclical": "#75206b",
                "Consumer Defensive": "#2F65DE",
                "Energy": "#025c1d",
                "Financial": "#3c4d3e",
                "Healthcare": "#1e3133",
                "Industrials": "#3f3c69",
                "Real Estate": "#693827",
                "Technology": "#2180CE",
                "Utilities": "#ab4f2b"
            },
            tableHeight: 0,
            loading: true,
            search: '',
            headers: [
                {
                    text: "Symbol",
                    align: 'center',
                    sortable: true,
                    value: 'symbol',
                },
                {
                    text: "Spot",
                    align: 'center',
                    sortable: true,
                    value: 'spot',
                },
                {
                    text: "Expiry",
                    align: 'center',
                    sortable: true,
                    filterable: false,
                    value: 'expiry',
                },
                {
                    text: "Strike",
                    align: 'center',
                    sortable: true,
                    filterable: false,
                    value: 'strike',
                },
                {
                    text: "Sum",
                    align: 'center',
                    sortable: true,
                    filterable: false,
                    value: 'sum',
                },
                {
                    text: "Time",
                    align: 'center',
                    sortable: true,
                    filterable: false,
                    value: 'epochTime',
                },
                {
                    text: "CP",
                    align: 'center',
                    sortable: true,
                    filterable: false,
                    value: 'cp',
                },
                {
                    text: "OI",
                    align: 'center',
                    sortable: true,
                    filterable: false,
                    value: 'oi',
                },
                {
                    text: "Trade",
                    align: 'center',
                    sortable: true,
                    filterable: false,
                    value: 'trade',
                },
                {
                    text: "Side",
                    align: 'center',
                    sortable: true,
                    filterable: false,
                    value: 'side',
                },
                {
                    text: "Cond",
                    align: 'center',
                    sortable: true,
                    filterable: false,
                    value: 'cond',
                },
            ],
            snapshotInitState: true,
            printData: [],
            prints: [],
        }),
        methods: {
            ...mapActions('elementVisibility', [
                'setLogoAndBottomNavVisibility'
            ]),
            showFlow(){
                this.$router.push({name: "OptionsFlow"});
            },

            showDark(){
                this.$router.push({name: "DarkPoolFlow"});
            },
            showCryptoFlow(){
            this.$router.push({name: "CryptoFlow"});
            },
            showShorts(){
            this.$router.push({name: "DashboardShort"});
            },
            showSector(){
            this.$router.push({name: "SectorFlow"});
            },
            showAccount(){
                this.$router.push({name: "Settings"});
            },
            filterPerfectMatch(value, search) {
                return value != null && value.toUpperCase() === search.toUpperCase()
            },
            getProfile: function(userCookie, authCookie) {
                fetch(BASE_URL + ENDPOINT + userCookie, {
                    headers: {
                        "x-access-token": authCookie
                    }
                }).then(response => {
                    return response.json()
                }).then(data => {
                    //self.userInfo = data[0];
                    this.userInfo = {
                        username: data[0]['username'],
                        avatar: `https://cdn.discordapp.com/avatars/${data[0]['userid']}/${data[0]['avatar']}.jpg`,
                        nextBillDate: data[0]['nextBillDate'],
                        paidDate: data[0]['paidDate'],
                        createdDate: data[0]['createdDate'],
                        subIDcurrent: data[0]['subID'],
                        userID: data[0]['userid'],
                        userTier: data[0]['userTier'],
                        premium: data[0]['premium'],
                    }
                }).catch(error => {
                    console.log(error);
                })
            },
            determinePrintType: function (print) {

                // TODO: Make these icons instead of text?
                //let exchange = print.exchange.split("|")[0];
                //if (exchange === "NQNX" || exchange === "BTRF" || exchange === "NTRF")
                //    return this.$vuetify.breakpoint.smAndDown ? `D` : "Dark";
                let lightText = this.$vuetify.breakpoint.smAndDown ? "AA" : "Above Ask"
                if (print.side === 3)
                    return this.$vuetify.breakpoint.smAndDown ? "AA" : "Above Ask"
                else if (print.side === 2) return this.$vuetify.breakpoint.smAndDown ? "A" : "Ask";
                else if (print.side === 1) return this.$vuetify.breakpoint.smAndDown ? "LA" : "Lean Ask";
                else if (print.side === 0) return this.$vuetify.breakpoint.smAndDown ? "B" : "Between";
                else if (print.side === -1) return this.$vuetify.breakpoint.smAndDown ? "LB" : "Lean Bid";
                else if (print.side === -2) return this.$vuetify.breakpoint.smAndDown ? "B" : "Bid";
                else if (print.side === -3) return this.$vuetify.breakpoint.smAndDown ? "BB" : "Below Bid";
                else return lightText;
            },
            determineCondType: function (print) {

                // TODO: Make these icons instead of text?
                //let exchange = print.exchange.split("|")[0];
                //if (exchange === "NQNX" || exchange === "BTRF" || exchange === "NTRF")
                //    return this.$vuetify.breakpoint.smAndDown ? `D` : "Dark";
                let lightText = "";
                if (print.cond.includes("OPENING")) return this.$vuetify.breakpoint.smAndDown ? `<span style="color: cyan">O</span>` : `<span style="color: cyan">OPENING</span>`;
                else if (print.cond.includes("COMPLEX")) return this.$vuetify.breakpoint.smAndDown ? "C" : "COMPLEX";
                else return lightText;
            },
            determineTradeType: function (print) {

                // TODO: Make these icons instead of text?
                //let exchange = print.exchange.split("|")[0];
                //if (exchange === "NQNX" || exchange === "BTRF" || exchange === "NTRF")
                //    return this.$vuetify.breakpoint.smAndDown ? `D` : "Dark";
                let lightText = "";
                if (print.trade.includes("SWEEP")) return this.$vuetify.breakpoint.smAndDown ? "S" : "SWEEP";
                else if (print.trade.includes("SPLIT")) return this.$vuetify.breakpoint.smAndDown ? "SP" : "SPLIT";
                else return lightText;
            },
            formatDate: function (millis) {
                let date = new Date(millis);
                return date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
            },
            abbrNum: abbreviateNumber,
            toExpanded: function (value) {
                let stockInfo = {
                    ticker: value.symbol,
                };

                this.$router.push({
                    name: "Expanded",
                    params: {
                        stockInfo: stockInfo
                    }
                });
            },
        }

    }
</script>

<style scoped>

    #button-container {
        display: grid;
        align-self: start;
        align-items: start;
        grid-template-rows: fit-content(1em) fit-content(1em) fit-content(1em);

        height: auto;
        width: 100%;
        margin-top: 15px;
    }


    #discord-button {
        position: relative;
        height: 52px;
        background-color: #7289DA;
    }

    #darkpool-button {
        position: relative;
        height: 62px;
        background-color: #404040;
        border: thin solid #CCCCCC;
    }
    #sector-button {
      position: relative;
      height: 62px;
      background-color: #404040;
      border: thin solid #CCCCCC;
    }

    #flow-button {
        position: relative;
        height: 62px;
        background-color: #404040;
        border: thin solid #CCCCCC;

    }

    #crypto-button {
      position: relative;
      height: 62px;
      background-color: #404040;
      border: thin solid #CCCCCC;

    }

    #account-button {
        position: relative;
        height: 62px;
        background-color: #404040;
        border: thin solid #CCCCCC;

    }
    #short-button {
      position: relative;
      height: 62px;
      background-color: #404040;
      border: thin solid #CCCCCC;

    }

    #streaming-container {
        height: 100%;
        width: 100%;
        background-color: #323232;
        overflow-y: auto;
    }

    #page-controls {
        flex: none;
        padding: 16px 16px;
        width: 100%;
        flex: none;
    }

    h1 {
        text-align:center;
    }

    div{
        text-align: -webkit-center;
    }

    #page-heading {
        flex: none;
        padding: 16px;
        color: black;
        flex: none;
        width: 100%;
        background-color: #E5E5E5;
    }

    #streaming-controls {
        width: auto;
    }

    #print-table {
        height: 100%;
        border-radius: 0 !important;
        width: 100%;
        overflow-y: auto;

        background-color: #323232;
        box-shadow: none;
    }

    .bid-ask-indicator {
        font-family: 'Verdana',  sans-serif !important;
    }

    .stock-sector-blip {
        height: 30px;
        width: 30px;
    }

    >>>th {
        padding: 16px 0 16px 14px !important;
    }
    >>>td {
        padding: 16px 0 !important;
    }



    >>>.v-skeleton-loader__table-tbody {
        background-color: #4C4C4C !important;
    }

    >>>tbody tr:nth-of-type(odd) {
        background-color: rgba(0, 0, 0, .05);
    }

    .style-1 {
        color: rgb(215,215,44)
    }
    .style-2 {
        color: rgb(114,114,67)
    }

    >>>tr {
        text-align: center !important;
    }

    .right-side-button-icon {
        position: absolute;
        height: 30px;
    }
</style>